import React, { useRef } from "react";
import { Box, InputLabel, FormControl, Typography, Button } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import "./fileUpload.css";

function FileUpload({
  name,
  label,
  accept,
  icon,
  value,
  onChange,
  onBlur,
  error = false,
  helperText = "",
}) {
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <FormControl fullWidth error={error} className="file-upload-control">
      {label && (
        <InputLabel
          shrink
          htmlFor={name}
          className={`file-upload-label ${error ? "error" : ""}`}
        >
          {label}
        </InputLabel>
      )}

      <Box className="file-upload-container">
        <input
          type="file"
          id={name}
          name={name}
          accept={accept}
          ref={fileInputRef}
          onChange={onChange}
          onBlur={onBlur}
          style={{ display: "none" }}
        />

        <Button
          variant="outlined"
          onClick={handleButtonClick}
          startIcon={icon || <AttachFileIcon />}
          className={`file-upload-button ${error ? "error" : ""}`}
          fullWidth
        >
          Choose File
        </Button>

        <Typography variant="body2" className="file-upload-text" noWrap>
          {value ? value : "No file chosen"}
        </Typography>
      </Box>

      {helperText && (
        <Typography variant="caption" className={`helper-text ${error ? "error" : ""}`}>
          {helperText}
        </Typography>
      )}
    </FormControl>
  );
}

export default FileUpload;